import { normalizeString } from './normalize-string';

export const processEmail = (email: string) => normalizeString(email);
